import { Component, inject, OnDestroy } from '@angular/core';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';

import { LoadOptions } from 'devextreme/data';
import { firstValueFrom, map, Observable, shareReplay, Subscription } from 'rxjs';
import { SessionService } from 'src/app/auth/session.service';
import { unsubscribeAll } from 'src/app/common/app.helpers';
import AppValues from 'src/app/common/app.values';
import { Session } from 'src/app/interfaces';
import { FilesActivityLogView } from 'src/app/interfaces/activity.interface';
import { ActivityLogEvent, FileDescriptorBase } from 'src/app/swagger-api';
import { FileDownload } from '../files/file-download.abstract';
import { FileManagerService } from '../files/file-manager.service';
import { loadOptionsToParams } from '../files/files-manager.helpers';
import { ActivitiesService } from './activities.service';

@Component({
  selector: 'app-activities-log',
  templateUrl: './activities.component.html',
  styleUrls: ['./activities.component.scss'],
})
export class ActivitiesComponent extends FileDownload implements OnDestroy {
  public readonly ACTIVITIES_PAGE_LIMIT: number = AppValues.PAGE_LIMIT;
  public readonly ACTIVITIES_PAGE_OFFSET: number = AppValues.ACTIVITIES_PAGE_OFFSET;
  public readonly ACTIVITIES_FILES_UPLOADED_EVENT: ActivityLogEvent.EventTypeEnum =
    ActivityLogEvent.EventTypeEnum.FilesUploadedEvent;
  public readonly ACTIVITIES_FILES_SHARED: ActivityLogEvent.EventTypeEnum = ActivityLogEvent.EventTypeEnum.FileShared;
  public readonly ACTIVITIES_FILES_DOWNLOADED: ActivityLogEvent.EventTypeEnum =
    ActivityLogEvent.EventTypeEnum.FileDownloaded;
  public readonly ACTIVITIES_FILES_REMOVED: ActivityLogEvent.EventTypeEnum = ActivityLogEvent.EventTypeEnum.FileRemoved;
  public readonly ACTIVITIES_FILES_UNSHARED: ActivityLogEvent.EventTypeEnum =
    ActivityLogEvent.EventTypeEnum.FileUnshared;
  public readonly ACTIVITIES_FILES_PERMISSION: ActivityLogEvent.EventTypeEnum =
    ActivityLogEvent.EventTypeEnum.FilePermissionUpdated;
  public readonly DATE_TIME_FORMAT_LONG: string = AppValues.DATE_TIME_FORMAT_LONG;

  public activitiesDataSource: DataSource = new DataSource({
    store: new CustomStore({
      key: 'event_id',
      load: async (loadOptions: LoadOptions) => {
        const response: FilesActivityLogView = await firstValueFrom(
          this.activitiesService.getAllActivities(loadOptionsToParams(loadOptions)),
        );

        return {
          data: response.items,
          totalCount: response.total_count,
        };
      },
    }),
  });

  private sessionService = inject(SessionService);
  private activitiesService = inject(ActivitiesService);
  private fileManagerService = inject(FileManagerService);

  private subscriptions$: Subscription[] = [];

  public readonly activeUserId$: Observable<string> = this.sessionService.sessionChanges.pipe(
    shareReplay(1),
    map((session: Session) => session.userId),
  );

  public ngOnDestroy(): void {
    unsubscribeAll(this.subscriptions$);
  }

  public displayPopup(data: FileDescriptorBase): void {
    this.titleToDisplay = data.entity_name;
    this.subscriptions$.push(
      this.fileManagerService.showAndDownloadFiles(data.entity_id).subscribe((url: string) => {
        this.protectedPublicURL = this.generateProtectedUrl(url);
        this.openingFile(url, data.content_type);
      }),
    );
  }
}
